import ReportSectionContent from "../../../components/UI/ReportSectionContent";
import { examCardEnums } from "../../../enums";
import EyeReport from "./EyeReport";

const RAPDReport = () => {
  return (
    <ReportSectionContent
      sectionName={examCardEnums.RAPD.sectionName}
      EyeReport={<EyeReport />}
    />
  );
};

export default RAPDReport;
